import { render, staticRenderFns } from "./ElHeadlineV3.vue?vue&type=template&id=e38baac0"
import script from "./ElHeadlineV3.vue?vue&type=script&lang=js"
export * from "./ElHeadlineV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports